import { SoundController } from "@lib/titan2-slingo/dist/game/controller/SoundController";
import { GameJaspurrsCupsSoundEvents } from "../event/GameSountEvent";
import { FeatureGreenFishEvents } from "../../view/abstract/display/features/greenfish/FeatureGreenFish";
import { MainTransitionEvents } from "../../view/abstract/display/GameMainTransition";
export class GameSoundJaspurrsCupsController extends SoundController {
    addEventListeners() {
        super.removeEventListeners();
        this.registerGame(FeatureGreenFishEvents.FEATURE_START, this.playMusic);
        this.registerGame(GameJaspurrsCupsSoundEvents.SHUFFLE, this.playShuffle);
        this.registerGame(GameJaspurrsCupsSoundEvents.LASER, this.playLaser);
        this.registerGame(GameJaspurrsCupsSoundEvents.CATNIP_UNCOVERED, this.handleCatnipUncovered);
        this.registerGame(GameJaspurrsCupsSoundEvents.CATNIP_CELEBRATION, this.handleCatnipCelebration);
        this.registerGame(GameJaspurrsCupsSoundEvents.TABLE_FLIP, this.handleTableFlip);
        this.registerGame(GameJaspurrsCupsSoundEvents.COLLECT_VALUE, this.handleCollectValue);
        this.registerGame(GameJaspurrsCupsSoundEvents.COLLECT_CASH_PRIZE, this.handleCollectCashPrize);
        this.registerGame(MainTransitionEvents.BLACKOUT_MID_POINT, this.stopMusic);
    }
    playMusic() {
        this.playSound(this.getSoundPropertiesFromId("CUPS_MUSIC"));
    }
    stopMusic() {
        this.stopSound(this.getSoundPropertiesFromId("CUPS_MUSIC"));
    }
    playShuffle() {
        this.playSound(this.getSoundPropertiesFromId("CUPS_SHUFFLE"));
    }
    playLaser() {
        this.playSound(this.getSoundPropertiesFromId("CUPS_LASER"));
    }
    handleCatnipUncovered() {
        this.playSound(this.getSoundPropertiesFromId("CUPS_CATNIP_UNCOVERED"));
    }
    handleCatnipCelebration() {
        this.playSound(this.getSoundPropertiesFromId("CUPS_CATNIP_CELEBRATION"));
    }
    handleTableFlip() {
        this.playSound(this.getSoundPropertiesFromId("CUPS_TABLE_FLIP"));
    }
    handleCollectValue() {
        this.playSound(this.getSoundPropertiesFromId("CUPS_COLLECT_VALUE"));
    }
    handleCollectCashPrize() {
        this.playSound(this.getSoundPropertiesFromId("CUPS_COLLECT_CASH_PRIZE"));
    }
}
//# sourceMappingURL=GameSoundJaspurrsCupsController.js.map